import styled from 'styled-components'
import media from '../../../styles/media'

export const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;

  ${media.md`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  `}
`
export const Copyright = styled.p`
  margin-top: 0;
  display: flex;
  flex-direction: column;
`

export const CopyrightSmall = styled.small`
  color: #6c757d;
`

export const Title = styled.h3`
  color: #007bff;
  line-height: 1.1;
  margin-top: 0;
`
export const Ul = styled.ul`
  list-style: none;
  padding: 0;
`
export const LinkCustom = styled.a`
  color: #6c757d;
  text-decoration: none;
`
